import {Decoder, equal, oneOf} from 'json-bouncer'

export type M = 'Print' | 'Litho'

export function decoder(): Decoder<M> {
    return oneOf([
        equal<M>('Print'),
        equal<M>('Litho'),
    ])
}

export function label(type: M): string {
    switch (type) {
        case 'Print':
            return 'Druck'
        case 'Litho':
            return 'Litho'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestOfferType.ts